import type { StatusHistoryEntry } from '../../hooks/useOrderQuery';

interface StatusTimelineProps {
  history: StatusHistoryEntry[];
  isLoading?: boolean;
}

export default function StatusTimeline({ history, isLoading }: StatusTimelineProps) {
  if (isLoading) {
    return <div className="animate-pulse h-32 bg-nb-cream rounded-[2px]" />;
  }

  if (!history || history.length === 0) {
    return <p className="text-sm text-nb-text-muted text-center py-4">No status history</p>;
  }

  // Sort chronologically (oldest first)
  const sorted = [...history].sort(
    (a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
  );

  return (
    <div className="space-y-0">
      {sorted.map((entry, index) => {
        const isLast = index === sorted.length - 1;
        const date = new Date(entry.created_at);
        const formattedDate = date.toLocaleDateString('es-ES', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        });
        const formattedTime = date.toLocaleTimeString('es-ES', {
          hour: '2-digit',
          minute: '2-digit',
        });

        return (
          <div key={entry.id || index} className="flex gap-3">
            {/* Timeline dot and line */}
            <div className="flex flex-col items-center">
              <div className={`w-3 h-3 rounded-full border-2 ${isLast ? 'bg-nb-black border-nb-black' : 'bg-white border-nb-black'}`} />
              {!isLast && <div className="w-0.5 flex-1 mt-1 bg-black" />}
            </div>

            {/* Content */}
            <div className={`flex-1 pb-4 ${!isLast ? '' : ''}`}>
              <p className="text-sm font-medium text-black">
                {entry.status_config?.name || entry.status || 'Unknown status'}
              </p>
              <p className="text-xs text-nb-text-muted">
                {formattedDate} at {formattedTime}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}